import React, { useCallback, useRef, useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
  DialogTitle,
  Chip,
  Paper,
} from "@mui/material";
import { useEffect } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import WebViewer from "@pdftron/webviewer";
import { toast } from "react-toastify";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import PDFViewer from "app/shared-components/PDFViewer";
import { useLocation } from "react-router-dom";
import Draggable from "react-draggable";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

function DraggablePaper({ handleId, ...props }) {
  const nodeRef = React.useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (isMobile) {
    return <Paper {...props} />;
  }

  return (
    <Draggable
      nodeRef={nodeRef}
      handle={`#${handleId}`}
      cancel={[
        '[class*="MuiDialogContent-root"]',
        '[class*="MuiDialogActions-root"]',
        '[class*="MuiIconButton-root"]',
        '[class*="MuiButton-root"]',
      ].join(", ")}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

const PdfPaperComponent = (props) => (
  <DraggablePaper handleId="view-pdf-dialog-title" {...props} />
);
const CommentPaperComponent = (props) => (
  <DraggablePaper handleId="view-pdf-comment-title" {...props} />
);
export default function ViewPDFEdit(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { open, handleClose, title } = props;
  const [value, SetValue] = useState("");
  const viewRef = useRef();
  const instanceRef = useRef();
  const [openComment, setOpenComment] = useState(false);
  const [submitDisable, setSubmitDisable] = useState(true);
  const location = useLocation();
  const showMinimize =
    !isMobile && /^\/order\/order-details\/[^/]+$/.test(location.pathname);
  const [isMinimized, setIsMinimized] = useState(false);
  const abNumber = title?.split("-")[1];
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [error, setError] = useState();
  const [pdfError, setPdfError] = useState("");

  const [valueComment, SetValueComment] = useState("");
  const [submitDisableComment, setSubmitDisableComment] = useState(true);

  const handleCommentChange = (event) => {
    SetValueComment(event.target.value);
  };

  useEffect(() => {
    if (valueComment) {
      setSubmitDisableComment(false);
    } else {
      setSubmitDisableComment(true);
    }
  }, [valueComment]);

  const loadABFile = async () => {
    try {
      setLoading(true);
      setHasError(false);

      if (props?.abFiles) {
        const fileId = Array.isArray(props?.abFiles)
          ? props.abFiles[0]?.id
          : props.abFiles?.id;
        const file = await OAuthService.getPostPdf(
          props?.partnerStatus
            ? `${url}api/downloadCustomerAbFile/${fileId}`
            : `${url}api/downloadAbFile/${fileId}`,
        );

        const blob = new Blob([file?.data], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
        setPdfUrl(blobUrl);
        setPdfError("");
      }
    } catch (error) {
      setHasError(true);
      toast.error(error?.response?.data?.errorMessage || "Error loading PDF");
      setPdfError("Error loading PDF");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (value) {
      setSubmitDisable(false);
    } else {
      setSubmitDisable(true);
    }
  }, [value]);

  useEffect(() => {
    if (open) {
      loadABFile();
    }
  }, [props?.open, open]);
  const handleMinimize = () => {
    setIsMinimized(true);
  };

  const handleMaximize = () => {
    setIsMinimized(false);
  };

  const minimizedDialogStyle = {
    position: "absolute",
    bottom: "50px",
    right: "50px",
    width: "200px",
    height: "200px",
    borderRadius: "8px",
    boxShadow: theme.shadows[8],
    zIndex: 9999,
    padding: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.grey[900]
        : theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.primary,
  };

  const saveHighlights = async () => {
    try {
      const id = Array.isArray(props?.abFiles)
        ? props.abFiles[0]?.id
        : props.abFiles?.id;
      const abNumber = Array.isArray(props?.abFiles)
        ? props.abFiles[0]?.abNumber
        : props.abFiles?.abNumber;

      // Fetching the PDF file as a blob
      let blob;
      try {
        const file = await OAuthService.getPostPdf(
          `${url}api/downloadAbFile/${id}`,
        );
        blob = new Blob([file?.data], { type: "application/pdf" });
      } catch (error) {
        console.error("Error fetching AB file:", error);
        toast.error("Failed to download AB file.");
        return;
      }

      // Creating a File object from the blob
      const abFile = new File([blob], `${abNumber}.pdf`, {
        type: "application/pdf",
      });

      // Prepare FormData for sending
      const formData = new FormData();
      formData.append("abPdf", abFile);

      try {
        await OAuthService.addFiles(
          `${url}api/sendAbNotification?abFileId=${id}&orderId=${props?.orderId}`,
          formData,
        );

        setSuccessMsg("AB file send to customer successfully");
        handleClose();
      } catch (error) {
        setError(error?.response?.data?.errorMessage || error.message);

        console.error("Error saving the PDF:", error);
        handleClose();
      }
    } catch (error) {
      console.error("Unexpected error:", error);
    }
  };
  const handleSendToCustomerComment = async () => {
    try {
      const id = Array.isArray(props?.abFiles)
        ? props.abFiles[0]?.id
        : props.abFiles?.id;
      const abNumber = Array.isArray(props?.abFiles)
        ? props.abFiles[0]?.abNumber
        : props.abFiles?.abNumber;

      // Fetching the PDF file as a blob
      let blob;
      try {
        const file = await OAuthService.getPostPdf(
          `${url}api/downloadAbFile/${id}`,
        );
        blob = new Blob([file?.data], { type: "application/pdf" });
      } catch (error) {
        console.error("Error fetching AB file:", error);
        toast.error("Failed to download AB file.");
        return;
      }

      const formData = new FormData();
      formData.append("abPdf", blob, `${abNumber}.pdf`);

      if (valueComment?.trim()) {
        formData.append("comment", valueComment);
      }

      await OAuthService.addFiles(
        `${url}api/sendAbNotification?abFileId=${id}&orderId=${props?.orderId}`,
        formData,
      );

      setSuccessMsg("AB file send to customer successfully");
      handleCommentPopupClose();
      handleClose();
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
      console.error("Error uploading the PDF:", error);
      handleCommentPopupClose();
      handleClose();
    }
  };

  const commentAndSend = async () => {
    setOpenComment(true);
  };

  const handleCommentPopupClose = () => {
    setOpenComment(false);
  };
  useEffect(() => {
    if (props?.handleSuccess) {
      props?.handleSuccess(successMsg);
    }
  }, [successMsg]);

  useEffect(() => {
    if (props?.handleError) {
      props?.handleError(error);
    }
  }, [error]);

  return (
    <>
      {isMinimized && showMinimize ? (
        <Box
          onClick={handleMaximize} // Click to maximize when minimized
          style={minimizedDialogStyle}
        >
          <Icon fontSize="large">
            <FuseSvgIcon size={30} color="secondary">
              heroicons-outline:document-text
            </FuseSvgIcon>
          </Icon>
          <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
            {abNumber}
          </Typography>

          {/* Close Button */}
          <IconButton
            onClick={handleClose}
            color="inherit"
            style={{
              position: "absolute",
              top: 5,
              right: 5,
              backgroundColor: theme.palette.action.hover,
              borderRadius: "50%",
              padding: 5,
            }}
          >
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </Box>
      ) : (
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth="xl"
          fullScreen={isMobile}
          PaperComponent={PdfPaperComponent}
          aria-labelledby="view-pdf-dialog-title"
        >
          <AppBar
            position="static"
            style={{ cursor: isMobile ? "default" : "move" }}
            id="view-pdf-dialog-title"
          >
            <Toolbar
              className="flex w-full justify-between"
              sx={{
                flexWrap: "wrap",
                gap: 1,
                py: { xs: 1, sm: 0 },
                minHeight: { xs: "auto", sm: 64 },
              }}
            >
              <Typography
                variant="subtitle1"
                color="inherit"
                noWrap
                sx={{ flex: { xs: "1 1 60%", sm: "0 1 auto" }, minWidth: 0 }}
              >
                {title}
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                {!props?.partnerStatus && (
                  <>
                    {!props?.abFiles?.sharedAbFileName && (
                      <Button
                        color="secondary"
                        variant="contained"
                        size="small"
                        disabled={
                          loading || hasError
                            ? false
                            : props?.orderStatus === "AB_RECEIVED" ||
                              props?.orderStatus === "UNDER_CONFIRMATION"
                            ? false
                            : true
                        }
                        startIcon={
                          <FuseSvgIcon>
                            heroicons-outline:annotation
                          </FuseSvgIcon>
                        }
                        onClick={commentAndSend}
                        aria-label="Add a Comment"
                        sx={{
                          minWidth: { xs: 40, sm: 64 },
                          "& .MuiButton-startIcon": {
                            mr: { xs: 0, sm: 1 },
                            ml: { xs: 0, sm: -0.5 },
                          },
                        }}
                      >
                        <Box
                          component="span"
                          sx={{ display: { xs: "none", sm: "inline" } }}
                        >
                          Add a Comment
                        </Box>
                      </Button>
                    )}
                    {!props?.abFiles?.sharedAbFileName && (
                      <Button
                        color="secondary"
                        variant="contained"
                        size="small"
                        disabled={
                          loading || hasError
                            ? false
                            : props?.orderStatus === "AB_RECEIVED" ||
                              props?.orderStatus === "UNDER_CONFIRMATION"
                            ? false
                            : true
                        }
                        startIcon={
                          <FuseSvgIcon>material-solid:email</FuseSvgIcon>
                        }
                        onClick={saveHighlights}
                        aria-label="Send to Customer"
                        sx={{
                          minWidth: { xs: 40, sm: 64 },
                          "& .MuiButton-startIcon": {
                            mr: { xs: 0, sm: 1 },
                            ml: { xs: 0, sm: -0.5 },
                          },
                        }}
                      >
                        <Box
                          component="span"
                          sx={{ display: { xs: "none", sm: "inline" } }}
                        >
                          Send to Customer
                        </Box>
                      </Button>
                    )}
                    {props?.abFiles?.sharedAbFileName && (
                      <Button
                        color="secondary"
                        variant="contained"
                        size="small"
                        sx={{
                          border: `3px solid ${theme.palette.divider}`,
                          pointerEvents: "none",
                        }}
                      >
                        Shared with Customer
                      </Button>
                    )}
                  </>
                )}

                {showMinimize && !isMinimized && (
                  <IconButton onClick={handleMinimize} color="inherit">
                    <Icon>remove</Icon>
                  </IconButton>
                )}
                <IconButton
                  onClick={handleClose}
                  color="inherit"
                  aria-label="Close"
                >
                  <Icon>close</Icon>
                </IconButton>
              </Box>
            </Toolbar>
          </AppBar>

          <DialogContent
            classes={{ root: "p-8 sm:p-12" }}
            sx={{
              p: { xs: 0.5, sm: 1.5 },
              overflow: "auto",
              WebkitOverflowScrolling: "touch",
            }}
          >
            {pdfUrl ? (
              <Box
                sx={{
                  width: "100%",
                  height: { xs: "calc(100dvh - 130px)", sm: "auto" },
                }}
              >
                <PDFViewer url={pdfUrl}  hideToolbar={isMobile}/>
              </Box>
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <Typography color="error" variant="body1">
                  {pdfError}
                </Typography>
              </Box>
            )}
          </DialogContent>
        </Dialog>
      )}
      <Dialog
        fullWidth
        maxWidth="md"
        fullScreen={isMobile}
        onClose={handleCommentPopupClose}
        open={openComment}
        PaperComponent={CommentPaperComponent}
        aria-labelledby="view-pdf-comment-title"
      >
        <AppBar
          position="static"
          sx={{ cursor: isMobile ? "default" : "move" }}
          id="view-pdf-comment-title"
        >
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              Add Comment
            </Typography>
            <IconButton
              onClick={handleCommentPopupClose}
              color="inherit"
              aria-label="Close"
            >
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-16 sm:p-24" }} sx={{ overflowY: "auto", WebkitOverflowScrolling: "touch" }}>
          <Box sx={{ mb: 2 }}>
            <TextField
              id="outlined-textarea"
              label="Comment"
              placeholder="Write your comment here"
              multiline
              fullWidth
              rows={isMobile ? 6 : 10}
              value={valueComment}
              onChange={handleCommentChange}
            />
          </Box>
          <Button
            type="button"
            variant="contained"
            color="secondary"
            size="large"
            fullWidth={isMobile}
            disabled={submitDisableComment}
            onClick={() => handleSendToCustomerComment(valueComment)}
          >
            Send to Customer
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
